import { render, staticRenderFns } from "./GeneralSplash.vue?vue&type=template&id=be03fb5c"
import script from "./GeneralSplash.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralSplash.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports